import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";

import MyContext from "./../context/context";

// MUI
import styled from "@emotion/styled";
import { AccessTime, BarChart, CalendarMonth, CameraAlt, CurrencyRupee, QrCode2, RateReview, School } from "@mui/icons-material";
import { Avatar, Badge, Box, Button, Card, CardContent, Chip, CircularProgress, Container, Dialog, DialogContent, Divider, Grid, IconButton, LinearProgress, Rating, Stack, TextField, Typography } from "@mui/material";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import QRCode from "react-qr-code";

export default function StudentHome({ snackbar }) {
	const api = useContext(MyContext);
	const [open, setOpen] = useState("");
	const [action, setAction] = useState("");
	const apiUrl = process.env.REACT_APP_STUDENT_V2;

	useEffect(() => {
		window.scroll(0, 0);
	}, []);

	const VisuallyHiddenInput = styled("input")({
		clip: "rect(0 0 0 0)",
		clipPath: "inset(50%)",
		height: 1,
		overflow: "hidden",
		position: "absolute",
		bottom: 0,
		left: 0,
		whiteSpace: "nowrap",
		width: 1,
	});

	useEffect(() => {
		profile();
	}, []);
	const [stu, setStu] = useState([]);
	const profile = () => {
		axios.get(`${api.api.student}?my-profile`).then(function (res) {
			if (res.data.status === true) {
				setStu(res.data.data);
			}
		});
	};

	useEffect(() => {
		dashboard();
	}, []);
	const [att, setAtt] = useState([]);
	const [pay, setPay] = useState([]);
	const [course, setCourse] = useState([]);
	const dashboard = () => {
		axios.get(`${api.api.student}?my-dashboard`).then(function (res) {
			if (res.data.status !== false) {
				if (res.data.att.status === true) {
					setAtt(res.data.att.data);
				}
				if (res.data.pay.status === true) {
					setPay(res.data.pay.data);
				}
				if (res.data.course.status === true) {
					setCourse(res.data.course.data);
				}
			}
		});
	};

	const change_photo = (event) => {
		snackbar("Uploading...");
		var formData = new FormData();
		formData.append("add-photo", stu.studentid);
		formData.append("image", event.target.files[0]);
		axios.post(api.api.student, formData).then(function (res) {
			if (res.data.status === true) {
				window.location.reload();
			}
		});
	};

	const location = useLocation();

	useEffect(() => {
		const handleOpenReview = () => setOpen("review");
		window.addEventListener('openReviewDialog', handleOpenReview);

		if (location.state?.openReview) {
			setOpen("review");
			window.history.replaceState({}, document.title);
		} else {
			axios.get(`${apiUrl}?action=my-review`).then(function (res) {
				if (res.data.status === false && !Cookies.get("reviewClosed")) {
					setOpen("review");
				}
			});
		}

		return () => window.removeEventListener('openReviewDialog', handleOpenReview);
	}, [location.state, apiUrl]);

	const [rating, setRating] = useState(0);
	const [review, setReview] = useState("");

	const post_review = () => {
		setAction("review");
		let formData = new FormData();
		formData.append("rating", rating);
		formData.append("review", review);
		axios.post(`${apiUrl}?action=post-review`, formData).then(function (res) {
			setAction("");
			Cookies.set("reviewClosed", "true", { expires: 3 });
			setOpen("");
			snackbar(res.data.msg);
		});
	};

	// Calculate payment percentage
	const totalPayable = parseInt(pay.fees || 0) - parseInt(pay.discount || 0);
	const paymentProgress = totalPayable > 0 ? (parseInt(pay.payed || 0) / totalPayable) * 100 : 0;
	const attendancePercentage = att.attend ? Math.min((att.attend / 30) * 100, 100) : 0;

	return (
		<Box sx={{ backgroundColor: '#fafbfc' }}>
			{/* QR Code Dialog */}
			<Dialog
				open={open === "qropen"}
				onClose={() => setOpen("")}
				PaperProps={{
					sx: {
						borderRadius: 3,
						border: '2px solid',
						borderColor: 'primary.main'
					}
				}}
			>
				<DialogContent sx={{ p: 4, textAlign: 'center' }}>
					<QrCode2 sx={{ fontSize: 56, color: 'primary.main', mb: 2 }} />
					<Typography variant="h6" fontWeight={700} color="primary.main" mb={1}>
						Attendance QR Code
					</Typography>
					<Typography variant="body2" color="text.secondary" mb={3}>
						Show this code to mark your attendance
					</Typography>
					<Box sx={{ p: 2, border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)', borderRadius: 2, backgroundColor: 'white' }}>
						<QRCode size={250} level="Q" value={stu.studentid === undefined ? "" : `spyware:attendance:${stu.studentid}:${stu.franchiseid}`} viewBox={`0 0 256 256`} />
					</Box>
					<Typography variant="caption" color="text.secondary" mt={2} display="block">
						ID: {stu.studentid}
					</Typography>
				</DialogContent>
			</Dialog>

			{/* Review Dialog */}
			<Dialog
				open={open === "review"}
				onClose={() => {
					Cookies.set("reviewClosed", "true", { expires: 3 });
					setOpen("");
				}}
				fullWidth
				maxWidth="sm"
				PaperProps={{
					sx: {
						borderRadius: 3,
						border: '2px solid',
						borderColor: 'info.main'
					}
				}}
			>
				<DialogContent sx={{ p: 4 }}>
					<Box textAlign="center" mb={3}>
						<RateReview sx={{ fontSize: 64, color: 'info.main', mb: 1 }} />
						<Typography variant="h5" fontWeight={700} color="text.primary" mb={1}>
							Share Your Feedback
						</Typography>
						<Typography variant="body2" color="text.secondary">
							Help us improve by rating your experience
						</Typography>
					</Box>

					<Stack spacing={3}>
						<Box textAlign="center">
							<Typography variant="body2" color="text.secondary" mb={1.5}>
								Rate your experience
							</Typography>
							<Rating
								name="half-rating"
								size="large"
								value={rating}
								onChange={(event) => setRating(event.target.value)}
								sx={{ fontSize: '2.5rem' }}
							/>
						</Box>

						<TextField
							fullWidth
							label="Your comments (optional)"
							multiline
							rows={4}
							value={review}
							onChange={(event) => setReview(event.target.value)}
							variant="outlined"
						/>

						<Button
							variant="contained"
							size="large"
							fullWidth
							color="info"
							onClick={() => post_review()}
							disabled={action === "review" || rating === 0}
							sx={{
								py: 1.5,
								textTransform: 'none',
								fontSize: 16,
								fontWeight: 600
							}}
						>
							{action === "review" ? <CircularProgress size={24} color="inherit" /> : "Submit Feedback"}
						</Button>
					</Stack>
				</DialogContent>
			</Dialog>

			<Container maxWidth="xl">
				<Box sx={{ pt: 3, pb: 3 }}>
					{/* Welcome Header */}
					<Box mb={3}>
						<Typography variant="h4" fontWeight={700} color="text.primary" className="orbitron">
							Welcome back, {stu.name?.split(' ')[0] || 'Student'}!
						</Typography>
						<Typography variant="body2" color="text.secondary" mt={0.5}>
							{new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
						</Typography>
					</Box>

					{/* Profile Card */}
					<Card sx={{ borderRadius: 3, mb: 3, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
						<CardContent sx={{ p: 3 }}>
							<Grid container spacing={3} alignItems="center">
								<Grid item xs={12} sm="auto">
									<Badge
										overlap="circular"
										anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
										badgeContent={
											<IconButton
												component="label"
												size="small"
												sx={{
													backgroundColor: 'primary.main',
													color: 'white',
													'&:hover': { backgroundColor: 'primary.dark' }
												}}
											>
												<CameraAlt sx={{ fontSize: 14 }} />
												<VisuallyHiddenInput onChange={(event) => change_photo(event)} type="file" accept=".jpeg, .jpg, .png" />
											</IconButton>
										}
									>
										<Avatar
											alt={stu.name}
											sx={{
												width: 80,
												height: 80,
												border: '3px solid',
												borderColor: 'primary.main'
											}}
											src={`${api.api.stuimg + stu.studentid}.jpg`}
										/>
									</Badge>
								</Grid>
								<Grid item xs={12} sm>
									<Typography fontSize={22} fontWeight={700} className="orbitron" color="primary.main">
										{stu.name}
									</Typography>
									<Typography variant="body2" color="text.secondary" fontWeight={500}>
										Roll No. {stu.rollno}
									</Typography>
								</Grid>
								<Grid item xs={12} sm="auto">
									<Button
										variant="contained"
										startIcon={<QrCode2 />}
										color="primary"
										fullWidth
										onClick={() => setOpen("qropen")}
										sx={{
											py: 1.5,
											px: 3,
											textTransform: 'none',
											fontWeight: 600,
											borderRadius: 2
										}}
									>
										Mark Attendance
									</Button>
								</Grid>
							</Grid>
						</CardContent>
					</Card>

					{/* Stats Overview */}
					<Grid container spacing={2} mb={3}>
						<Grid item xs={6} md={3}>
							<Card sx={{ borderRadius: 3, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
								<CardContent sx={{ p: 2.5 }}>
									<Stack spacing={1}>
										<Box sx={{
											width: 48,
											height: 48,
											borderRadius: 2,
											backgroundColor: '#FEE2E2',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center'
										}}>
											<CalendarMonth sx={{ color: '#DC2626', fontSize: 28 }} />
										</Box>
										<Typography variant="h4" fontWeight={700} color="#DC2626">
											{att.attend || 0}
										</Typography>
										<Typography variant="caption" color="text.secondary" fontWeight={600}>
											Days Present
										</Typography>
										<Divider sx={{ my: 0.5 }} />
										<Typography variant="caption" color="text.secondary" fontSize={11}>
											Attend in joined course
										</Typography>
									</Stack>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={6} md={3}>
							<Card sx={{ borderRadius: 3, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
								<CardContent sx={{ p: 2.5 }}>
									<Stack spacing={1}>
										<Box sx={{
											width: 48,
											height: 48,
											borderRadius: 2,
											backgroundColor: '#D1FAE5',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center'
										}}>
											<CurrencyRupee sx={{ color: '#059669', fontSize: 28 }} />
										</Box>
										<Typography variant="h4" fontWeight={700} color="#059669">
											{Math.round(paymentProgress)}%
										</Typography>
										<Typography variant="caption" color="text.secondary" fontWeight={600}>
											Fees Paid
										</Typography>
										<Divider sx={{ my: 0.5 }} />
										<Typography variant="caption" color="text.secondary" fontSize={11}>
											₹{parseInt(pay.payed || 0).toLocaleString("en-in")} / ₹{totalPayable.toLocaleString("en-in")}
										</Typography>
									</Stack>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={6} md={3}>
							<Card sx={{ borderRadius: 3, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
								<CardContent sx={{ p: 2.5 }}>
									<Stack spacing={1}>
										<Box sx={{
											width: 48,
											height: 48,
											borderRadius: 2,
											backgroundColor: '#FEF3C7',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center'
										}}>
											<School sx={{ color: '#D97706', fontSize: 28 }} />
										</Box>
										<Typography variant="h4" fontWeight={700} color="#D97706">
											{course.length}
										</Typography>
										<Typography variant="caption" color="text.secondary" fontWeight={600}>
											Active Courses
										</Typography>
										<Divider sx={{ my: 0.5 }} />
										<Typography variant="caption" color="text.secondary" fontSize={11}>
											{course.length > 0 ? course[0].c_title : 'No courses'}
										</Typography>
									</Stack>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={6} md={3}>
							<Card sx={{ borderRadius: 3, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
								<CardContent sx={{ p: 2.5 }}>
									<Stack spacing={1}>
										<Box sx={{
											width: 48,
											height: 48,
											borderRadius: 2,
											backgroundColor: '#DBEAFE',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center'
										}}>
											<BarChart sx={{ color: '#2563EB', fontSize: 28 }} />
										</Box>
										<Typography variant="h4" fontWeight={700} color="#2563EB">
											₹{(totalPayable - parseInt(pay.payed || 0)).toLocaleString("en-in")}
										</Typography>
										<Typography variant="caption" color="text.secondary" fontWeight={600}>
											Balance Due
										</Typography>
										<Divider sx={{ my: 0.5 }} />
										<Typography variant="caption" color="text.secondary" fontSize={11}>
											{parseInt(pay.discount || 0) > 0 ? `Discount: ₹${parseInt(pay.discount).toLocaleString("en-in")}` : 'No discount'}
										</Typography>
									</Stack>
								</CardContent>
							</Card>
						</Grid>
					</Grid>

					{/* Today's Schedule */}
					<Card sx={{ borderRadius: 3, mb: 3, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
						<CardContent sx={{ p: 3 }}>
							<Typography variant="h6" fontWeight={700} mb={2}>
								Today's Attendance
							</Typography>
							<Grid container spacing={2}>
								<Grid item xs={12} sm={6}>
									<Box sx={{ p: 2, border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)', borderRadius: 2 }}>
										<Stack direction="row" alignItems="center" spacing={2}>
											<Box sx={{
												width: 48,
												height: 48,
												borderRadius: 2,
												backgroundColor: 'rgba(38, 166, 154, 0.1)',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center'
											}}>
												<AccessTime sx={{ color: 'info.main', fontSize: 24 }} />
											</Box>
											<Box>
												<Typography variant="caption" color="text.secondary">
													Check In
												</Typography>
												<Typography variant="h6" fontWeight={700}>
													{att.at_in !== null ? new Date(att.at_in).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", hour12: true }) : "Not marked"}
												</Typography>
											</Box>
										</Stack>
									</Box>
								</Grid>
								<Grid item xs={12} sm={6}>
									<Box sx={{ p: 2, border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)', borderRadius: 2 }}>
										<Stack direction="row" alignItems="center" spacing={2}>
											<Box sx={{
												width: 48,
												height: 48,
												borderRadius: 2,
												backgroundColor: 'rgba(255, 167, 38, 0.1)',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center'
											}}>
												<AccessTime sx={{ color: 'warning.main', fontSize: 24 }} />
											</Box>
											<Box>
												<Typography variant="caption" color="text.secondary">
													Check Out
												</Typography>
												<Typography variant="h6" fontWeight={700}>
													{att.at_out !== null ? new Date(att.at_out).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", hour12: true }) : "Not marked"}
												</Typography>
											</Box>
										</Stack>
									</Box>
								</Grid>
							</Grid>
						</CardContent>
					</Card>

					{/* Payment & Courses Row */}
					<Grid container spacing={3}>
						<Grid item xs={12} md={6}>
							<Card sx={{ borderRadius: 3, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)', height: '100%' }}>
								<CardContent sx={{ p: 3 }}>
									<Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
										<Box sx={{
											width: 40,
											height: 40,
											borderRadius: 2,
											backgroundColor: '#D1FAE5',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center'
										}}>
											<CurrencyRupee sx={{ color: '#059669', fontSize: 24 }} />
										</Box>
										<Typography variant="h6" fontWeight={700}>
											Fee Details
										</Typography>
									</Stack>
									<Stack spacing={2}>
										<Stack direction="row" justifyContent="space-between">
											<Typography variant="body2" color="text.secondary">Total Fees</Typography>
											<Typography variant="body1" fontWeight={700}>₹{parseInt(pay.fees || 0).toLocaleString("en-in")}</Typography>
										</Stack>
										{parseInt(pay.discount || 0) > 0 && (
											<Stack direction="row" justifyContent="space-between">
												<Typography variant="body2" color="success.main">Discount</Typography>
												<Typography variant="body1" fontWeight={600} color="success.main">-₹{parseInt(pay.discount).toLocaleString("en-in")}</Typography>
											</Stack>
										)}
										<Divider />
										<Stack direction="row" justifyContent="space-between">
											<Typography variant="body2" color="text.secondary" fontWeight={600}>Payable</Typography>
											<Typography variant="h6" fontWeight={700} color="primary.main">₹{totalPayable.toLocaleString("en-in")}</Typography>
										</Stack>
										<Box sx={{ backgroundColor: '#f5f5f5', borderRadius: 2, p: 2 }}>
											<Stack spacing={1}>
												<Stack direction="row" justifyContent="space-between">
													<Typography variant="body2" color="text.secondary">Paid</Typography>
													<Typography variant="body1" fontWeight={700} color="info.main">₹{parseInt(pay.payed || 0).toLocaleString("en-in")}</Typography>
												</Stack>
												<Stack direction="row" justifyContent="space-between">
													<Typography variant="body2" color="text.secondary">Balance</Typography>
													<Typography variant="body1" fontWeight={700} color="warning.main">₹{(totalPayable - parseInt(pay.payed || 0)).toLocaleString("en-in")}</Typography>
												</Stack>
											</Stack>
										</Box>
										<LinearProgress
											variant="determinate"
											value={paymentProgress}
											sx={{
												height: 8,
												borderRadius: 4,
												backgroundColor: 'rgba(0,0,0,0.06)'
											}}
										/>
									</Stack>
								</CardContent>
							</Card>
						</Grid>

						<Grid item xs={12} md={6}>
							<Card sx={{ borderRadius: 3, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)', height: '100%' }}>
								<CardContent sx={{ p: 3 }}>
									<Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
										<Box sx={{
											width: 40,
											height: 40,
											borderRadius: 2,
											backgroundColor: '#FEF3C7',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center'
										}}>
											<School sx={{ color: '#D97706', fontSize: 24 }} />
										</Box>
										<Typography variant="h6" fontWeight={700}>
											My Courses
										</Typography>
									</Stack>
									<Stack spacing={1.5}>
										{course.map((row, i) => (
											<Box
												key={i}
												sx={{
													p: 2,
													borderRadius: 2,
													border: '1px solid',
													borderColor: 'rgba(0, 0, 0, 0.07)',
													backgroundColor: '#fafbfc',
													transition: 'all 0.2s',
													'&:hover': {
														borderColor: 'warning.main',
														backgroundColor: 'rgba(255, 167, 38, 0.02)'
													}
												}}
											>
												<Typography variant="body1" fontWeight={700} color="text.primary" mb={1}>
													{row.c_name}
												</Typography>
												<Stack direction="row" spacing={1}>
													<Chip size="small" label={row.c_title} variant="outlined" color="warning" />
													<Chip size="small" label={`${row.c_duration} Months`} variant="outlined" color="info" />
												</Stack>
											</Box>
										))}
									</Stack>
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				</Box>
			</Container>
		</Box>
	);
}
